import { Header, Sections } from 'components';
import _get from 'lodash.get';
import React, { PureComponent } from 'react';
import { Helmet } from 'react-helmet';
import { DataStoreService } from 'utils';
import CustomHelmet from '../components/helmet/helmet.component';
import { HelmetDatoCms } from 'gatsby-source-datocms';
import { graphql } from 'gatsby';

export default class PageTemplate extends PureComponent {
    constructor(props) {
        super(props);
        DataStoreService.setServices(_get(props, 'data.services', null));
        DataStoreService.setCases(_get(props, 'data.cases', null));
        DataStoreService.setThoughts(_get(props, 'data.thoughts', null));
        DataStoreService.setPeople(_get(props, 'data.people', null));
        DataStoreService.setJobs(_get(props, 'data.jobs', null));
    }

    componentDidMount() {
    }

    render() {
        const { data, location } = this.props;
        
        const pageBackgroundColor = _get(
            data,
            'page.backgroundColor.hex',
            '#fff'
        );
        return data ? (
            <>
                <CustomHelmet
                    siteSeo={_get(data, 'site.globalSeo', '')}
                    pageSeo={_get(data, 'page.seo', '')}
                />
                <HelmetDatoCms
                    favicon={_get(data, 'site.faviconMetaTags', '')}
                />
                <Helmet>
                    <body className={`${data.page.slug}-page showfallback_`} />
                    <style>{`html,body { background-color: ${pageBackgroundColor}; }`}</style>
                </Helmet>
                <Header
                    {...{
                        ...this.props,
                        getTransitionContent: this.renderWrapper,
                    }}
                />{' '}
                <Sections {...this.props} />{' '}
            </>
        ) : (
            <div>loading</div>
        );
    }
}

export const PageTemplateQuery = graphql`
    query pageTemplate($slug: String!) {
        site: datoCmsSite {
            ...DatoCmsSiteFragment
        }
        page: datoCmsPage(slug: { eq: $slug }) {
            name
            slug
            textColor {
                hex
            }
            backgroundColor {
                hex
            }
            seo {
                title
                description
                twitterCard
                image {
                    format
                    size
                    width
                    height
                    url
                }
            }
            redirect
            hero {
                __typename
                ... on DatoCmsHeroImage {
                    ...DatoCmsHeroImageFragment
                }
                ... on DatoCmsHeroText {
                    id
                    title
                    titleForMobileDevices
                    disableDifferenceEffect
                    color {
                        red
                        green
                        blue
                        rgb
                        hex
                    }
                }
                ... on DatoCmsServicesHero {
                    id
                    label
                    headline
                    backgroundColor {
                        red
                        green
                        blue
                        rgb
                        hex
                    }
                    textColor {
                        red
                        green
                        blue
                        rgb
                        hex
                    }
                }
            }
            modules {
                __typename
                ... on DatoCmsViewsNewsList {
                    id
                }
                ... on DatoCmsFeaturedCase {
                    id
                    layout
                    translateX
                    case {
                        ...DatoCmsFeaturedCaseFragment
                    }
                }
                ... on DatoCmsFeaturedPageLink {
                    id
                    subtitle
                    title
                    layout
                    translateX
                    page {
                        slug
                        hero {
                            __typename
                            ... on DatoCmsHeroImage {
                                image {
                                    format
                                    #removed inlineSvg
                                    url
                                    sizes {
                                        #(maxWidth: 1500)
                                        ...GatsbyDatoCmsSizes_noBase64
                                    }
                                }
                            }
                            ... on DatoCmsHeroText {
                                title
                            }
                        }
                    }
                }
                ... on DatoCms3ColumnText {
                    id
                    column1
                    column2
                    column3
                }
                ... on DatoCmsNextCase {
                    id
                    case {
                        ...DatoCmsFeaturedCaseFragment
                    }
                    page {
                        slug
                    }
                    text
                    image {
                        format
                        #removed inlineSvg
                        url
                        sizes {
                            #(maxWidth: 1000)
                            ...GatsbyDatoCmsSizes_noBase64
                        }
                    }
                }
                ... on DatoCmsApproach {
                    id
                    heroText
                    sections
                    section1
                    section2
                    section3
                }
                ... on DatoCmsCaseList {
                    id
                }
                # ... on DatoCmsContactBar {
                #     ...DatoCmsContactBarFragment
                # }
                # ... on DatoCmsGetInTouch {
                #     id
                #     text
                # }
                ... on DatoCmsLinkBar {
                    id
                    linkText
                    link {
                        slug
                    }
                }
                ... on DatoCmsLargeVideoImage {
                    id
                    ...DatoCmsLargeVideoImageFragment
                }
                ... on DatoCmsSmallVideoImage {
                    id
                    ...DatoCmsSmallVideoImageFragment
                }
                ... on DatoCmsPeopleList {
                    id
                }
                ... on DatoCmsCaseSection {
                    id
                    sectionTitle
                }
                ... on DatoCmsSpacer100 {
                    id
                    size
                }
                ... on DatoCmsSpacer200 {
                    id
                }
                ... on DatoCmsSpacer300 {
                    id
                }
                ... on DatoCmsLayoutLine {
                    id
                    linelayout
                }
                ... on DatoCmsDescriptionPlusText {
                    id
                    descriptionLabel
                    descriptionBody
                    text
                }
                ... on DatoCmsDescriptionPlusCaseList {
                    id
                    additionalCases {
                        ...DatoCmsFeaturedCaseFragment
                        tags {
                            tag
                        }
                    }
                    descriptionBody
                    descriptionLabel
                    featuredCases {
                        ...DatoCmsFeaturedCaseFragment
                        tags {
                            tag
                        }
                    }
                }
                ... on DatoCmsDescriptionPlusContact {
                    id
                    contactPerson {
                        ...DatoCmsPersonFragment
                    }
                    descriptionBody
                    descriptionLabel
                }
                ... on DatoCmsTextSection {
                    id
                    label
                    body
                }
                ... on DatoCmsMarkdownText {
                    id
                    text
                    centerText
                    leftAlignText
                    backgroundColor {
                        hex
                    }
                    textColor {
                        hex
                    }
                }
                ... on DatoCmsWorkTextWithFilter {
                    id
                    text
                }
                ... on DatoCmsContactPerson {
                    id
                    title
                    person {
                        ...DatoCmsPersonFragment
                    }
                    body
                }
                ... on DatoCmsTypetester {
                    id
                    ...DatoCmsTypetesterFragment
                }
                ... on DatoCmsSideBySideTextImage {
                    ...DatoCmsSideBySideTextImageFragment
                }
                ... on DatoCmsSideBySideTextCarousel {
                    ...DatoCmsSideBySideTextCarouselFragment
                }
                ... on DatoCmsSideBySideText {
                    id
                    left
                    right
                }
                ... on DatoCmsFooter {
                    id
                }
                ... on DatoCmsIframe {
                    id
                    url
                }
            }
        }
        contactBar: datoCmsContentsForContactBar {
            id
            firstAddress
            secondAddress
            links {
                id
                title
                url
            }
        }
        footer: datoCmsContentsForFooter {
            id
            heroText
            firstAddress
            secondAddress
            additionText
        }
        cases: allDatoCmsCase(
            sort: { fields: [position], order: ASC }
            filter: { name: { ne: "-" }, locale: { eq: "en" }, awardsPage: {eq: false} }
        ) {
            edges {
                node {
                    ...DatoCmsCaseFragment
                }
            }
        }
        thoughts: allDatoCmsViewsNews(
            sort: { fields: [date], order: DESC }
            filter: { title: { ne: "-" }, locale: { eq: "en" } }
        ) {
            edges {
                node {
                    ...DatoCmsViewsNewsFragment
                }
            }
        }
        people: allDatoCmsPerson(
            sort: { fields: [position], order: ASC }
            filter: { locale: { eq: "en" } }
        ) {
            edges {
                node {
                    ...DatoCmsPersonFragment
                }
            }
        }
        menu: datoCmsMenuItem {
            largeMenuItems {
                id
                slug
                name
                redirect
            }
            smallMenuItems {
                id
                slug
                name
                redirect
            }
        }
        services: allDatoCmsService(sort: {fields: position, order: ASC}) {
            edges {
                node {
                    service
                }
            }
        }
        jobs: allDatoCmsJob(
            filter: { title: { ne: "-" }, locale: { eq: "en" } }
        ) {
            edges {
                node {
                    id
                    title
                    intro
                    image {
                        sizes {
                            #(maxWidth: 1000)
                            ...GatsbyDatoCmsSizes_noBase64
                        }
                    }
                    slug
                    location {
                        location
                        code
                    }
                }
            }
        }
    }
`;
